import { useState, MouseEvent } from 'react';
// Context
import { useEditContactApi } from '../../../../../../../../../../context/EditContactApiContext';
import { useNavigateContext } from '../../../../../../../../../../context/NavigateContext';
// Types
import type { IContact, IBusiness } from '@trii/types/dist/Contacts';

// Maneja la tarjeta (ContactInfoPopup) del contacto que ya tiene asociado el address.
// Al abrir, pide sus datos con fetchContact y expone el estado del popover.
export const useContactInfoPopup = (contactId: string | null) => {
  const api = useEditContactApi();
  const navigate = useNavigateContext();

  const [contactData, setContactData] = useState<IContact | IBusiness | null>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const openPopup = async (event: MouseEvent<HTMLElement>) => {
    if (!contactId || !api) return;

    // Guardar el elemento antes del await
    const targetElement = event.currentTarget;
    setIsLoading(true);

    try {
      const contact = await api.fetchContact({ contactId });
      setContactData(contact);
      setAnchorEl(targetElement);
    } finally {
      setIsLoading(false);
    }
  };

  const closePopup = () => setAnchorEl(null);

  return {
    contactData,
    anchorEl,
    isOpen: Boolean(anchorEl),
    isLoading,
    openPopup,
    closePopup,
    navigate,
  };
};
